import { cn } from "@/lib/utils";

/** Review is desk-capable; capture stays phone-width. Caps to a phone
 * column on small screens and widens to a desk layout from md up. */
function ReviewShell({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className="h-dvh w-full overflow-hidden bg-muted/40">
      <div
        className={cn(
          "mx-auto flex h-full w-full max-w-md md:max-w-[1400px] flex-col overflow-y-auto",
          "pt-[env(safe-area-inset-top)]",
          className,
        )}
        data-slot="review-shell"
        {...props}
      />
    </div>
  );
}

export { ReviewShell };
